// 近代化資金　お申込情報
import React from 'react';
import { mp_flg as mp_flg_value, ma_flg as ma_flg_value } from '../Const';
import ShowBusinessImprovementFinancingPlanButton from '../../ts/molecules/ShowBusinessImprovementFinancingPlanButton';
import ShowModernizationFundButton from '../../ts/molecules/ShowModernizationFundButton';
import Heading from '../molecules/Heading';

interface Props {
  mp_flg: number; // 借入申込希望書兼経営改善資金計画書フラグ
  ma_flg: number; // 近代化資金借入申込書フラグ
  status_code: number;
}

const ModernizationFundApplicationInfo: React.FC<Props> = ({ mp_flg, ma_flg, status_code }) => {
  return (
    <>
      <Heading size="m" label="お申込情報" />
      {/* 『借入申込希望書兼経営改善資金計画書』ボタン表示 */}
      {(mp_flg === mp_flg_value.completion ||
        mp_flg === mp_flg_value.loan_approval_has_been_coordinated) && (
        <ShowBusinessImprovementFinancingPlanButton status_code={status_code} />
      )}

      {/* 『借入申込書』ボタン表示 */}
      {(ma_flg === ma_flg_value.completion ||
        ma_flg === ma_flg_value.loan_approval_has_been_coordinated) && (
        <ShowModernizationFundButton status_code={status_code} />
      )}
    </>
  );
};

export default ModernizationFundApplicationInfo;
